import { ResourcesConfig } from 'aws-amplify';
import { environment } from '../../../environments/environment';

export const AMPLIFY_CONFIG: ResourcesConfig = {
  API: {
    GraphQL: {
      endpoint: environment.amplify.graphqlEndpoint,
      region: environment.amplify.region,
      defaultAuthMode: 'apiKey',
      apiKey: environment.amplify.apiKey
    }
  }
};
